<template>

    <div id="report-complete">

        <div class="py-6" v-if="loaded">

            <ReportJobIndex v-model="form" @exportReport="exportReport" v-if="form.indexHasResults()"></ReportJobIndex>
            <div class="no-results panel" v-else>
                <div class="p-10">
                    <div class="text-gray-200 my-6">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 mx-auto" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                        </svg>
                    </div>

                    <h2 class="text-gray-600 font-medium text-2xl text-center">No Completed Reports</h2>

                    <p class="text-center mt-4 text-sm text-gray-500">
                        We could not find any completed reports in the last 28 days, <a href="#" @click.prevent="showReportIndex">run a report</a>.
                    </p>
                </div>
            </div>
            <infinite-loading class="py-6 text-center text-xs uppercase font-medium text-gray-600" @infinite="infiniteHandler">
                <div slot="no-results">No Pending Reports</div>
                <div slot="no-more">&nbsp;</div>
                <div slot="error">An Error Occurred, contact support.</div>
                <div slot="spinner"><Loading></Loading></div>
            </infinite-loading>

        </div>
        <Loading message="Loading Completed Reports" v-else></Loading>

    </div>

</template>

<script>
import Loading from "../Support/Loading";
import {ReportJob} from "../../app/Report/ReportJob";
import InfiniteLoading from "vue-infinite-loading";
import ReportJobIndex from "./ReportJobIndex";
import {PermissionMixin} from "../../support/mixins";

export default {
    name: "ReportComplete",
    mixins: [PermissionMixin],
    components: {
        ReportJobIndex,
        InfiniteLoading,
        Loading
    },
    data() {
        return {
            form: false,
            loaded: false,
        }
    },
    methods: {
        showReportIndex() {
            this.$emit('showReportIndex');
        },
        exportReport(uuid) {
            let vm = this;

            vm.form.exportReport(uuid).catch(error => vm.handleError(error));
        },
        infiniteHandler($state) {
            let vm = this;

            vm.form.page += 1;

            if (vm.form.indexHasMoreResults()) {
                this.form.index(true).then(r => {
                    $state.loaded();
                }).catch(error => vm.handleError(error));
            } else {
                $state.loaded();
                $state.complete();
            }
        }
    },
    mounted() {
        let vm = this;

        new Promise(resolve => {
            vm.form = new ReportJob();

            vm.form.index(false).then(r => {
                resolve(true);
            });
        }).then(r => {
            vm.loaded = r;
        })
    }
}
</script>
